import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

import Icon from 'components/UIKit/Icon'

const ActionIcon = styled(Icon)`
  margin: 0 ${theme('spacing.xs')};
`

export default ActionIcon
